import { MapPrivacy, MapOwnerFilter } from 'features/maps/types'
import { useMeUser } from 'features/users/hooks/useMeUser'
import { useMemo } from 'react'

export function useUserMapsPermissionsMapping() {
  const user = useMeUser()
  const ownerId = user?.user_id
  const PermissionsMapping = useMemo(
    () => ({
      [MapOwnerFilter.All]: {
        user_id: undefined,
        privacy: undefined
      },
      [MapOwnerFilter.Mine]: {
        user_id: ownerId,
        privacy: undefined
      },
      [MapOwnerFilter.Shared]: {
        user_id: undefined,
        privacy: MapPrivacy.Shared
      },
      [MapOwnerFilter.Public]: {
        user_id: undefined,
        privacy: MapPrivacy.Public
      }
    }),
    [ownerId]
  )
  return (permissions: MapOwnerFilter) => PermissionsMapping[permissions]
}
